const REWARD_ID_PARAM = 'rewardId';
const REWARD_ID_ROUTE_PARAM = `:${REWARD_ID_PARAM}`;
const STORE_ID_PARAM = 'storeId';
const STORE_ID_ROUTE_PARAM = `:${STORE_ID_PARAM}`;
const PROMO_ID_PARAM = 'promo';
const PROMO_ID_ROUTE_PARAM = `:${PROMO_ID_PARAM}`;
const BRAND_ID_PARAM = 'brandId';
const BRAND_ID_ROUTE_PARAM = `:${BRAND_ID_PARAM}`;
const GIFT_CARD_ID_PARAM = 'giftCardId';
const GIFT_CARD_ID_ROUTE_PARAM = `:${GIFT_CARD_ID_PARAM}`;
const DEAL_ID_PARAM = 'dealId';
const DEAL_ID_ROUTE_PARAM = `:${DEAL_ID_PARAM}`;
const WF_RETURN_URL_SEARCH_PARAM = 'wfreturnUrl';
const WF_DEVICE_ID_SEARCH_PARAM = 'wfedid';

const REGISTER_CODE_PARAM = 'code';
const REGISTER_SIGN_PARAM = 'sign';
const REGISTER_SIGNED_AT_PARAM = 'signed-at';
const REGISTER_PIN_PARAM = 'pin';
const REGISTER_OPTIN_PARAM = 'optin';
const REGISTER_SIGNUP_PARAM = 'signup';
const REGISTER_FROM_PARAM = 'from';
const REGISTER_DATA_PARAM = 'data';
const REGISTER_SOURCE_PARAM = 'source';
const REGISTER_TOPIC_PARAM = 'topic';
const REGISTER_FROM_CHECKOUT_PARAM = 'fromCheckout';
const REGISTER_ORIGIN_URL_PARAM = 'originUrl';
const REGISTER_PARTNER_ID_PARAM = 'partnerId';
const REGISTER_PARTNER_NAME_PARAM = 'partnerName';

const TYPE_SEARCH_PARAM = 'loginType';
const EMAIL_SEARCH_PARAM = 'loginEmail';
const CATEGORY_SEARCH_PARAM = 'category';
const SORT_SEARCH_PARAM = 'sort';
const AUTH_TOKEN_SEARCH_PARAM = 'authToken';
const EMBED_LOGIN_BACKGROUND_SEARCH_PARAM = 'backGround';
const REDIRECT_SEARCH_PARAM = 'redirect';
const DEEP_LINK_STORAGE_KEY = 'deepLinkRedirect';
const FILTER_SEARCH_PARAMS = {
  TYPE: 'type',
  MIN_VALUE: 'minValue',
  MAX_VALUE: 'maxValue',
  IS_NEW: 'isNew',
};
const TAB_SEARCH_PARAM = 'tab';

const ROUTE_HOME = '/';
const ROUTE_LOGIN = '/login';
const ROUTE_EMBED = '/embed';
const ROUTE_EMBED_LOGIN = `${ROUTE_EMBED}${ROUTE_LOGIN}`;
const ROUTE_BROWN_FORM = '/brown-form';
const ROUTE_EMBED_BROWN_FORM = `${ROUTE_EMBED}${ROUTE_BROWN_FORM}`;
const ROUTE_LOGOUT = '/logout';
const ROUTE_SIGNUP = '/signup';
const ROUTE_SETTINGS = '/settings';
const ROUTE_ADDRESSES = '/addresses';
const ROUTE_DASHBOARD = '/earnings';
const ROUTE_DASHBOARD_REWARDS = '/rewards';
const ROUTE_REDEEM = '/redeem';
const ROUTE_REGISTER = '/register';
const ROUTE_MY_ACCOUNT = '/account';
/** Mobile-style notifications inbox deeplink; web opens account drawer → notifications tab */
const ROUTE_WEB_NOTIFICATIONS_INBOX = '/notifications';
const ROUTE_WEB_NOTIFICATIONS_INBOX_ACCOUNT = `${ROUTE_MY_ACCOUNT}/notifications`;
const ROUTE_PROFILE = `${ROUTE_MY_ACCOUNT}/details`;
const ROUTE_WALLET = '/wallet';
const ROUTE_TAKE_BACK_BAGS = '/take-back-bags';
const ROUTE_TAKE_BACK_BAGS_DETAILS = `${ROUTE_TAKE_BACK_BAGS}/details`;
const ROUTE_REWARD = '/reward';
const ROUTE_REWARD_ID = `${ROUTE_REWARD}/${REWARD_ID_ROUTE_PARAM}`;
const ROUTE_REWARDS = '/trashiecash-rewards';
const ROUTE_REWARD_INFO = `${ROUTE_REWARDS}${ROUTE_REWARD}/${REWARD_ID_ROUTE_PARAM}`;
const ROUTE_STORE = '/store';
const ROUTE_REWARDS_STORE_ID = `${ROUTE_REWARDS}${ROUTE_STORE}/${STORE_ID_ROUTE_PARAM}`;
const ROUTE_REWARDS_STORE_REWARD_ID = `${ROUTE_REWARDS}${ROUTE_STORE}/${STORE_ID_ROUTE_PARAM}/${REWARD_ID_ROUTE_PARAM}`;
const ROUTE_DEALS = '/trashiecash-deals';
const ROUTE_DEAL_STORE_ID = `${ROUTE_DEALS}${ROUTE_STORE}/${STORE_ID_ROUTE_PARAM}`;
const ROUTE_DEAL_STORE_REWARD_ID = `${ROUTE_DEALS}${ROUTE_STORE}/${STORE_ID_ROUTE_PARAM}/${REWARD_ID_ROUTE_PARAM}`;
const ROUTE_DEAL = '/deal';
const ROUTE_DEAL_INFO = `${ROUTE_DEALS}${ROUTE_DEAL}/${REWARD_ID_ROUTE_PARAM}`;
const ROUTE_GIFT_CARDS = '/trashiecash-gift-cards';
const ROUTE_BRAND = '/brand';
const ROUTE_GIFT_CARDS_BRAND_ID = `${ROUTE_GIFT_CARDS}${ROUTE_BRAND}/${BRAND_ID_ROUTE_PARAM}`;
const ROUTE_GIFT_CARD = '/gift-card';
const ROUTE_GIFT_CARD_INFO = `${ROUTE_GIFT_CARDS}${ROUTE_GIFT_CARD}/${GIFT_CARD_ID_ROUTE_PARAM}`;

const ROUTE_SHARE = '/share';
const ROUTE_SHARE_DEALS = `${ROUTE_SHARE}/deals`;
const ROUTE_SHARE_DEAL_ID = `${ROUTE_SHARE_DEALS}/${DEAL_ID_ROUTE_PARAM}`;
const ROUTE_SHARE_STORES = `${ROUTE_SHARE}/stores`;
const ROUTE_SHARE_STORE_ID = `${ROUTE_SHARE_STORES}/${STORE_ID_ROUTE_PARAM}`;
const ROUTE_SHARE_STORE_DEAL_ID = `${ROUTE_SHARE_STORE_ID}/deals/${DEAL_ID_ROUTE_PARAM}`;

const ROUTE_REWARDS_OLD = '/rewards';
const ROUTE_REWARDS_OLD_STORE_ID = `${ROUTE_REWARDS_OLD}${ROUTE_STORE}/${STORE_ID_ROUTE_PARAM}`;
const ROUTE_REWARDS_OLD_STORE_REWARD_ID = `${ROUTE_REWARDS_OLD_STORE_ID}/${REWARD_ID_ROUTE_PARAM}`;
const ROUTE_REWARD_OLD_INFO = `${ROUTE_REWARDS_OLD}${ROUTE_REWARD}/${REWARD_ID_ROUTE_PARAM}`;

const ROUTE_TRANSACTIONS = '/transactions';
const ROUTE_OFFERS = '/earn-trashiecash';

const ROUTE_REWARDS_V2 = '/deals';
const ROUTE_REWARDS_V2_LIST = `${ROUTE_REWARDS_V2}/list`;
const ROUTE_REWARDS_V2_STORE_ID = `${ROUTE_REWARDS_V2}${ROUTE_STORE}/${STORE_ID_ROUTE_PARAM}`;
const ROUTE_REWARDS_V2_STORE_REWARD_ID = `${ROUTE_REWARDS_V2_STORE_ID}/${REWARD_ID_ROUTE_PARAM}`;
const ROUTE_GIFT_CARDS_V2 = '/gift-cards';
const ROUTE_GIFT_CARDS_V2_LIST = `${ROUTE_GIFT_CARDS_V2}/list`;
const ROUTE_GIFT_CARDS_V2_BRAND_ID = `${ROUTE_GIFT_CARDS_V2}${ROUTE_BRAND}/${BRAND_ID_ROUTE_PARAM}`;
const ROUTE_OFFERS_V2 = '/shop-and-earn';

const ROUTE_SUBSCRIPTION = '/subscription';
const ROUTE_UNLIMITED = '/unlimited';
const ROUTE_TRASHIE_UNLIMITED = '/trashie-unlimited';
const SUBSCRIPTION_FROM_CHECKOUT_PARAM = 'fromCheckout';
const SUBSCRIPTION_ORDER_ITEMS_PARAM = 'orderItems';

const ROUTE_ONE_TIME_ORDER = '/one-time-order';
const ONE_TIME_ORDER_PRODUCTS_PARAM = 'products';
const ONE_TIME_ORDER_ADDRESS_PARAM = 'address';

const ROUTE_MOBILE_LOGIN = '/mobile-login';

const ROUTE_MOBILE_VERIFY_EMAIL = '/mobile-verify-email';

const ROUTE_WELCOME_BACK = '/welcome-back';

const ROUTE_MEMBERSHIP = '/membership';
const ROUTE_MANAGE_MEMBERSHIP = `${ROUTE_MEMBERSHIP}/manage`;
const ROUTE_MEMBERSHIP_ADDRESSES = `${ROUTE_MEMBERSHIP}/addresses`;
const ROUTE_MEMBERSHIP_ORDERS = `${ROUTE_MEMBERSHIP}/orders`;
const ROUTE_MEMBERSHIP_PAYMENT_METHOD = `${ROUTE_MEMBERSHIP}/payment-method`;
const MEMBERSHIP_CONFIRM_PARAM = 'confirm';
const ROUTE_MEMBERSHIP_CANCEL = `${ROUTE_MANAGE_MEMBERSHIP}/cancel`;
const STRIPE_SETUP_INTENT_CLIENT_SECRET_PARAM = 'setup_intent_client_secret';
const STRIPE_CHECKOUT_SESSION_ID_PARAM = 'checkout_session_id';
const STRIPE_PAYMENT_INTENT_ID_PARAM = 'payment_intent_id';
/** Localhost + development only: append `&devSuccess=1` with `fromCheckout=true` to preview the checkout success UI without Stripe (e.g. http://localhost:3030/unlimited?fromCheckout=true&devSuccess=1). */
const SUBSCRIPTION_DEV_SUCCESS_PREVIEW_PARAM = 'devSuccess';

const isSubscriptionDevSuccessPreview = () => process.env.NODE_ENV === 'development' && typeof window !== 'undefined' && window.location.hostname === 'localhost' && new URLSearchParams(window.location.search).get(SUBSCRIPTION_DEV_SUCCESS_PREVIEW_PARAM) === '1';

const ANCHOR_BALANCE = 'balance';
const ANCHOR_REWARDS = 'rewards';
const ANCHOR_OFFERS = 'offers';
const ANCHOR_PRODUCTS = 'products';
const ANCHOR_WALLET = 'wallet';
const ANCHOR_MY_REWARDS = 'myrewards';
const ANCHOR_MY_TBB = 'mytbbb';
const ANCHOR_TRANSACTIONS = 'transactions';
const ANCHOR_DEALS = 'deals';
const ANCHOR_GIFT_CARDS = 'giftcards';

const ROUTE_BALANCE = `${ROUTE_DASHBOARD}#${ANCHOR_BALANCE}`;

const ROUTES_TREE = {
  children: {
    [ROUTE_LOGIN]: {
      title: 'Login',
    },
    [ROUTE_LOGOUT]: {
      title: 'Logout',
    },
    [ROUTE_REWARDS_V2]: {
      title: 'Deals',
      children: {
        [ROUTE_REWARDS_V2_LIST]: {
          title: 'Deals',
          children: {
            [ROUTE_REWARDS_V2_STORE_ID]: {
              title: 'Deal details',
            },
            [ROUTE_REWARDS_V2_STORE_REWARD_ID]: {
              title: 'Deal details',
            },
          },
        },
        [ROUTE_OFFERS_V2]: {
          title: 'Shop and earn',
        },
      },
    },
    [ROUTE_GIFT_CARDS_V2]: {
      title: 'Gift Cards',
      children: {
        [ROUTE_GIFT_CARDS_V2_LIST]: {
          title: 'Gift Cards',
          children: {
            [ROUTE_GIFT_CARDS_V2_BRAND_ID]: {
              title: 'Gift Card details',
            },
          },
        },
      },
    },
    [ROUTE_DASHBOARD]: {
      title: 'Deals',
      children: {
        [ROUTE_DEALS]: {
          title: 'Instant Deals',
          children: {
            [ROUTE_DEAL_STORE_ID]: {
              title: 'Deal details',
            },
            [ROUTE_DEAL_STORE_REWARD_ID]: {
              title: 'Deal details',
            },
          },
        },
        [ROUTE_GIFT_CARDS]: {
          title: 'Gift Cards',
          children: {
            [ROUTE_GIFT_CARDS_BRAND_ID]: {
              title: 'Gift Card details',
            },
          },
        },
        [ROUTE_OFFERS]: {
          title: 'Earn TrashieCash™',
        },
      },
    },
    [ROUTE_DASHBOARD_REWARDS]: {
      title: 'Rewards',
      children: {
        [ROUTE_REWARDS]: {
          title: 'Premium Rewards',
          children: {
            [ROUTE_REWARDS_STORE_ID]: {
              title: 'Reward details',
            },
            [ROUTE_REWARDS_STORE_REWARD_ID]: {
              title: 'Reward details',
            },
          },
        },
      },
    },
    [ROUTE_MY_ACCOUNT]: {
      title: 'Account',
      children: {
        [ROUTE_PROFILE]: {
          title: 'Account details',
          children: {
            [ROUTE_SETTINGS]: {
              title: 'Change Password',
            },
          },
        },
        [ROUTE_TRANSACTIONS]: {
          title: 'Transactions',
        },
        [ROUTE_MANAGE_MEMBERSHIP]: {
          title: 'Manage Membership',
          children: {
            [ROUTE_MEMBERSHIP_CANCEL]: {
              title: '',
            },
            [ROUTE_MEMBERSHIP_PAYMENT_METHOD]: {
              title: 'Change Membership Card',
            },
          },
        },
        [ROUTE_MEMBERSHIP_ORDERS]: {
          title: 'Membership Activity',
        },
        [ROUTE_MEMBERSHIP_ADDRESSES]: {
          title: 'Membership Addresses',
        },
      },
    },
    [ROUTE_MEMBERSHIP]: {
      title: 'Trashie Unlimited',
    },
    [ROUTE_WALLET]: {
      title: 'Wallet',
      children: {
        [ROUTE_DEAL_INFO]: {
          title: 'Deal details',
        },
        [ROUTE_GIFT_CARD_INFO]: {
          title: 'Gift Card details',
        },
        [ROUTE_REWARD_INFO]: {
          title: 'Reward details',
        },
      },
    },
    [ROUTE_TAKE_BACK_BAGS]: {
      title: 'Recycle',
      children: {
        [ROUTE_TAKE_BACK_BAGS_DETAILS]: {
          title: 'Label details',
        },
      },
    },
    [ROUTE_REWARD_ID]: {
      title: 'Reward',
    },
    [ROUTE_REGISTER]: {
      title: 'Register',
    },
    [ROUTE_SUBSCRIPTION]: {
      title: 'Trashie Unlimited',
    },
    [ROUTE_UNLIMITED]: {
      title: 'Trashie Unlimited',
    },
    [ROUTE_TRASHIE_UNLIMITED]: {
      title: 'Trashie Unlimited',
    },
    [ROUTE_ONE_TIME_ORDER]: {
      title: 'One-Time Purchase',
    },
  },
};

/** Mobile inbox deeplinks — not a product URL (see NotificationsInboxWebRedirect) */
function isNotificationInboxWebPath(pathname) {
  if (!pathname || typeof pathname !== 'string') {
    return false;
  }
  return pathname === ROUTE_WEB_NOTIFICATIONS_INBOX
    || pathname === ROUTE_WEB_NOTIFICATIONS_INBOX_ACCOUNT;
}

export {
  // Params
  REWARD_ID_PARAM,
  REWARD_ID_ROUTE_PARAM,
  STORE_ID_PARAM,
  STORE_ID_ROUTE_PARAM,
  PROMO_ID_PARAM,
  PROMO_ID_ROUTE_PARAM,
  TYPE_SEARCH_PARAM,
  EMAIL_SEARCH_PARAM,
  CATEGORY_SEARCH_PARAM,
  SORT_SEARCH_PARAM,
  FILTER_SEARCH_PARAMS,
  TAB_SEARCH_PARAM,
  WF_RETURN_URL_SEARCH_PARAM,
  WF_DEVICE_ID_SEARCH_PARAM,
  REGISTER_CODE_PARAM,
  REGISTER_SIGN_PARAM,
  REGISTER_SIGNED_AT_PARAM,
  REGISTER_PIN_PARAM,
  REGISTER_OPTIN_PARAM,
  REGISTER_SIGNUP_PARAM,
  REGISTER_FROM_PARAM,
  REGISTER_DATA_PARAM,
  REGISTER_SOURCE_PARAM,
  REGISTER_TOPIC_PARAM,
  REGISTER_FROM_CHECKOUT_PARAM,
  REGISTER_ORIGIN_URL_PARAM,
  REGISTER_PARTNER_ID_PARAM,
  REGISTER_PARTNER_NAME_PARAM,
  AUTH_TOKEN_SEARCH_PARAM,
  EMBED_LOGIN_BACKGROUND_SEARCH_PARAM,
  REDIRECT_SEARCH_PARAM,
  DEEP_LINK_STORAGE_KEY,
  BRAND_ID_PARAM,
  BRAND_ID_ROUTE_PARAM,
  GIFT_CARD_ID_PARAM,
  GIFT_CARD_ID_ROUTE_PARAM,
  DEAL_ID_PARAM,
  DEAL_ID_ROUTE_PARAM,
  SUBSCRIPTION_FROM_CHECKOUT_PARAM,
  SUBSCRIPTION_ORDER_ITEMS_PARAM,
  ONE_TIME_ORDER_PRODUCTS_PARAM,
  ONE_TIME_ORDER_ADDRESS_PARAM,
  // Routes
  ROUTE_HOME,
  ROUTE_LOGIN,
  ROUTE_EMBED,
  ROUTE_EMBED_LOGIN,
  ROUTE_EMBED_BROWN_FORM,
  ROUTE_LOGOUT,
  ROUTE_SIGNUP,
  ROUTE_SETTINGS,
  ROUTE_PROFILE,
  ROUTE_ADDRESSES,
  ROUTE_DASHBOARD,
  ROUTE_REDEEM,
  ROUTE_REGISTER,
  ROUTE_BALANCE,
  ROUTE_DASHBOARD_REWARDS,
  ROUTE_OFFERS,
  ROUTE_TRANSACTIONS,
  ROUTE_WALLET,
  ROUTE_TAKE_BACK_BAGS,
  ROUTE_TAKE_BACK_BAGS_DETAILS,
  ROUTE_MY_ACCOUNT,
  ROUTE_WEB_NOTIFICATIONS_INBOX,
  ROUTE_WEB_NOTIFICATIONS_INBOX_ACCOUNT,
  isNotificationInboxWebPath,
  ROUTE_REWARDS,
  ROUTE_REWARD,
  ROUTE_REWARD_ID,
  ROUTE_REWARDS_STORE_ID,
  ROUTE_REWARDS_STORE_REWARD_ID,
  ROUTE_REWARD_INFO,
  ROUTE_STORE,
  ROUTE_REWARDS_OLD,
  ROUTE_REWARDS_OLD_STORE_ID,
  ROUTE_REWARDS_OLD_STORE_REWARD_ID,
  ROUTE_REWARD_OLD_INFO,
  ROUTE_DEALS,
  ROUTE_DEAL_STORE_ID,
  ROUTE_DEAL_STORE_REWARD_ID,
  ROUTE_DEAL_INFO,
  ROUTE_GIFT_CARDS,
  ROUTE_GIFT_CARDS_BRAND_ID,
  ROUTE_GIFT_CARD_INFO,
  ROUTE_SHARE,
  ROUTE_SHARE_DEALS,
  ROUTE_SHARE_DEAL_ID,
  ROUTE_SHARE_STORES,
  ROUTE_SHARE_STORE_ID,
  ROUTE_SHARE_STORE_DEAL_ID,
  ROUTE_REWARDS_V2,
  ROUTE_REWARDS_V2_LIST,
  ROUTE_REWARDS_V2_STORE_ID,
  ROUTE_REWARDS_V2_STORE_REWARD_ID,
  ROUTE_GIFT_CARDS_V2,
  ROUTE_GIFT_CARDS_V2_LIST,
  ROUTE_GIFT_CARDS_V2_BRAND_ID,
  ROUTE_OFFERS_V2,
  ROUTE_SUBSCRIPTION,
  ROUTE_UNLIMITED,
  ROUTE_TRASHIE_UNLIMITED,
  ROUTE_ONE_TIME_ORDER,
  ROUTE_MOBILE_LOGIN,
  ROUTE_MEMBERSHIP,
  ROUTE_MANAGE_MEMBERSHIP,
  ROUTE_MEMBERSHIP_ORDERS,
  ROUTE_MEMBERSHIP_ADDRESSES,
  ROUTE_MEMBERSHIP_PAYMENT_METHOD,
  ROUTE_MEMBERSHIP_CANCEL,
  MEMBERSHIP_CONFIRM_PARAM,
  STRIPE_SETUP_INTENT_CLIENT_SECRET_PARAM,
  STRIPE_CHECKOUT_SESSION_ID_PARAM,
  STRIPE_PAYMENT_INTENT_ID_PARAM,
  SUBSCRIPTION_DEV_SUCCESS_PREVIEW_PARAM,
  isSubscriptionDevSuccessPreview,
  ROUTES_TREE,
  ROUTE_MOBILE_VERIFY_EMAIL,
  ROUTE_WELCOME_BACK,
  // Anchors
  ANCHOR_BALANCE,
  ANCHOR_OFFERS,
  ANCHOR_REWARDS,
  ANCHOR_PRODUCTS,
  ANCHOR_WALLET,
  ANCHOR_MY_REWARDS,
  ANCHOR_MY_TBB,
  ANCHOR_TRANSACTIONS,
  ANCHOR_DEALS,
  ANCHOR_GIFT_CARDS,
};
